import {types} from '../types/types';




//*********** ACTIVAR LOADING ***********/

export const loadingActivateAction = () => ({
    type: types.loadingActivate
});

export const loadingDeactivateAction = () => ({
    type: types.loadingDeactivate
});

